import { Colors } from "@constants";
import React from "react";
import { TouchableOpacity, View, Text, StyleSheet } from "react-native";

type CGUCheckboxProps = {
  label: string | React.ReactNode;
  checked: boolean;
  onChange: () => void;
};

const CGUCheckbox = ({ label, checked, onChange }: CGUCheckboxProps) => {
  return (
    <View style={styles.checkboxItem}>
      <TouchableOpacity
        style={[styles.checkbox, checked && styles.checkboxChecked]}
        onPress={onChange}
      >
        {checked && <Text style={styles.checkmark}>✓</Text>}
      </TouchableOpacity>
      <Text style={styles.checkboxText}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  checkboxItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 20,
    paddingHorizontal: 20,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 2,
    borderColor: Colors.foodiBlack,
    marginRight: 12,
    marginTop: 2,
    alignItems: "center",
    justifyContent: "center",
  },
  checkboxChecked: {
    backgroundColor: Colors.foodiBlack,
  },
  checkmark: {
    color: Colors.white,
    fontSize: 14,
    fontWeight: "bold",
  },
  checkboxText: {
    flex: 1,
    fontSize: 14,
    color: Colors.foodiBlack,
    lineHeight: 20,
  },
});

export default CGUCheckbox;
